import { QueryFetcher } from '@app/models/core/query-fetcher.model';
import { Rl1 } from '@app/models/payroll/rl1.model';
import { EmployeeTaxFormsTable } from './employee-tax-forms.table';

export class EmployeeRL1Table extends EmployeeTaxFormsTable<Rl1> {
    type = 'RL1' as const;
    get query(): QueryFetcher<Rl1> {
        return Rl1.param('company', this.auth.company.id)
            .where('rl1_summary_id', this.summary.id ?? 0)
            .limit(this.PAGE_SIZE);
    }

    setColumns(): void {
        this.type = 'RL1'; // Needs to be re-set here in order for the super class to have this value
        super.setColumns();
    }
}
